"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lemmy_world = void 0;
var types_1 = require("../types");
exports.lemmy_world = {
    name: 'lemmy_world',
    matches: [
        {
            match: '(https?://)?lemmy.world/u/({PROFILE_ID})/?', group: 2, type: types_1.TYPE_DESKTOP,
            pattern: 'https://lemmy.world/u/{PROFILE_ID}'
        },
        { match: '@?({PROFILE_ID})', group: 1 },
    ]
};
//# sourceMappingURL=lemmy_world.js.map